import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type { ObjectId } from '@bb/domain/dist/mongodb';

const findPublicBBUserInfoByMlsNumber = async (
  uid: string,
  boardId: ObjectId,
) => {
  const config: AxiosRequestConfig = {
    url: `/user/info`,
    method: 'get',
    params: {
      uid,
      boardId,
    },
  };

  const { data } = await axios.request(config);

  return data;
};

export default findPublicBBUserInfoByMlsNumber;
